import { useRef } from "react";
import { Check } from "lucide-react";

export function ProgressBar({ steps, current }) {
  return (
    <div className="no-print" data-testid="progress-bar">
      <div className="mb-2 flex items-center justify-between">
        <span className="fc-mono text-[11px] uppercase tracking-wider" style={{ color: "var(--fc-secondary-text)" }}>
          Étape {current} sur {steps.length}
        </span>
        <span className="text-sm font-medium text-foreground">{steps[current - 1]}</span>
      </div>
      <div className="flex gap-1.5">
        {steps.map((_, i) => (
          <div key={i} className="h-1.5 flex-1 overflow-hidden rounded-full" style={{ backgroundColor: "var(--fc-surface2)" }}>
            <div
              className="h-full rounded-full transition-all duration-500"
              style={{
                width: i < current ? "100%" : "0%",
                backgroundColor: i < current ? "var(--fc-navy)" : "transparent",
              }}
            />
          </div>
        ))}
      </div>
    </div>
  );
}

export function ChoiceGroup({ value, onChange, options, name, testid }) {
  const ref = useRef(null);

  const handleKey = (e, idx) => {
    const btns = ref.current?.querySelectorAll("button[role=radio]") || [];
    if (/^[1-9]$/.test(e.key)) {
      const i = parseInt(e.key, 10) - 1;
      if (i < options.length) {
        e.preventDefault();
        onChange(options[i].value);
        btns[i]?.focus();
      }
    } else if (["ArrowRight", "ArrowDown"].includes(e.key)) {
      e.preventDefault();
      btns[(idx + 1) % options.length]?.focus();
    } else if (["ArrowLeft", "ArrowUp"].includes(e.key)) {
      e.preventDefault();
      btns[(idx - 1 + options.length) % options.length]?.focus();
    }
  };

  return (
    <div ref={ref} role="radiogroup" aria-label={name} className="grid gap-2.5 sm:grid-cols-3" data-testid={testid}>
      {options.map((opt, idx) => {
        const active = value === opt.value;
        return (
          <button
            key={opt.value}
            type="button"
            role="radio"
            aria-checked={active}
            tabIndex={active || (!value && idx === 0) ? 0 : -1}
            onClick={() => onChange(opt.value)}
            onKeyDown={(e) => handleKey(e, idx)}
            data-testid={`${testid}-${opt.value}`}
            className="fc-choice relative flex items-center justify-between gap-2 rounded-xl border-2 bg-card px-4 py-3.5 text-left text-sm font-medium"
            style={{
              borderColor: active ? "var(--fc-navy)" : "hsl(var(--border))",
              backgroundColor: active ? "var(--fc-surface2)" : "hsl(var(--card))",
              color: "hsl(var(--foreground))",
            }}
          >
            <span>
              <span className="fc-mono mr-2 text-[11px]" style={{ color: "var(--fc-secondary-text)" }}>
                {idx + 1}
              </span>
              {opt.label}
            </span>
            {active && (
              <span
                className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full"
                style={{ backgroundColor: "var(--fc-navy)" }}
              >
                <Check size={13} color="#fff" />
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}

export const YN = [
  { value: "oui", label: "Oui" },
  { value: "non", label: "Non" },
  { value: "nsp", label: "Je ne sais pas" },
];
